import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImage from "@/assets/hero-beach.jpg";
const Hero = () => {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img src={heroImage} alt="Singles connecting through travel experiences" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground/60 via-foreground/40 to-foreground/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/20 text-primary-foreground text-sm font-medium mb-6 backdrop-blur-sm animate-fade-in">
            A Clean Slate for Modern Dating
          </span>
          
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-primary-foreground mb-6 leading-tight animate-fade-in" style={{
          animationDelay: "0.1s"
        }}>
            Twenty hearts. One escape
          </h1>
          
          <p className="text-lg md:text-xl text-primary-foreground/80 mb-4 max-w-2xl mx-auto animate-fade-in" style={{
          animationDelay: "0.2s"
        }}>
            Slate us bridges the gap between a solo adventure and a matchmaking service. 
            Connect through shared experiences in beautiful places.
          </p>
          
          <p className="text-base md:text-lg text-primary-foreground/70 mb-8 max-w-2xl mx-auto animate-fade-in italic" style={{
          animationDelay: "0.25s"
        }}>
            Travel Solo, Never Alone
          </p>

          <div className="flex justify-center mb-12 animate-fade-in" style={{
          animationDelay: "0.3s"
        }}>
            <Button variant="hero" size="xl" asChild>
              <a href="#trips">Explore Trips</a>
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
          
        </div>
      </div>
    </section>;
};
export default Hero;